import React from "react";
import LandingsManagerBase from "./LandingsManagerBase";
import { fetchPublicVenues, venuesForZone } from "../utils/landingsInventory";

// Ubicaciones (FRA-288): reusa la colección `ciudades`. Cada doc activo
// publica su landing /ubicaciones/{slug} (y /en/locations/{slug}) y su
// sección en el homepage. `name` debe coincidir EXACTO con el campo `zone`
// de los venues (es el join contra el inventario).

const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

const config = {
  collection: "ciudades",
  title: "Ubicaciones",
  singular: "ubicación",
  nuevoLabel: "Nueva ubicación",
  subtitle:
    "Cada ubicación activa publica su landing en /ubicaciones/{slug} (y /en/locations/{slug}) sin deploy. El orden es el de las secciones del homepage.",
  identityFields: [
    {
      path: "name",
      label: "Zona (match con venues)",
      placeholder: "CDMX",
      hint: "Debe coincidir exactamente con el valor de zona de los venues (Datos del Sistema → Zonas).",
    },
    {
      path: "slug",
      label: "Slug (URL)",
      placeholder: "cdmx",
      hint: "URL pública: venueboard.com/ubicaciones/{slug}",
      warnOnEdit:
        "Cambiar el slug de una landing publicada rompe la URL indexada (SEO).",
    },
    { path: "titulo.ES", label: "Título (ES)", placeholder: "Ciudad de México" },
    { path: "titulo.EN", label: "Título (EN)", placeholder: "Mexico City" },
    {
      path: "ogImage",
      label: "Imagen OG (ruta)",
      placeholder: "/og/og-cdmx.jpg",
      hint: "Ruta en public/ del homesite; usada al compartir la landing.",
    },
  ],
  rowLabel: (d) => d.titulo?.ES || d.name || "(sin título)",
  rowDetail: (d) => `zona: ${d.name || "?"} · /ubicaciones/${d.slug || "?"}`,
  // Cuántos venues públicos caen en la zona de cada ubicación.
  loadCounts: async (items) => {
    const venues = await fetchPublicVenues();
    return Object.fromEntries(
      items.map((i) => [i.id, venuesForZone(venues, i.name).length])
    );
  },
  newDraft: () => ({
    name: "",
    slug: "",
    titulo: { ES: "", EN: "" },
    ogImage: "/og/og-default.jpg",
    activo: false,
    orden: 999,
    homeDesc: { ES: "", EN: "" },
    landing: { ES: null, EN: null },
  }),
  docIdFor: (draft) => draft.slug,
  validateDraft: (draft) => {
    if (!draft.name?.trim()) return "Falta la zona (match con venues)";
    if (!SLUG_RE.test(draft.slug || ""))
      return "Slug inválido (minúsculas, números y guiones)";
    if (!draft.titulo?.ES?.trim()) return "Falta el título en español";
    return null;
  },
};

export default function CiudadesManager() {
  return <LandingsManagerBase config={config} />;
}
